__webpack_require__.p = "/study-buddy/";